import { Avatar } from './Avatar';

export interface PaneHeaderProps {
  // The entity the pane is about: a person (owner/helper) or a record whose
  // identity is a person. `kind="dog"` is supported for completeness.
  avatar: { name: string; id: string; kind?: 'person' | 'dog' };
  title: string;
  // Extra badge beside the title (e.g. the first-stay "New" indicator).
  badge?: React.ReactNode;
  // Right-aligned header content (e.g. the booking status pill).
  right?: React.ReactNode;
  sub?: React.ReactNode;
  // Show the "New" badge beside the title (create flows).
  isNew?: boolean;
  // When set, the avatar becomes a button (e.g. open edit-owner from a booking pane).
  onAvatarClick?: () => void;
}

// The pane identity header used across every modal pane (booking, owner, leave,
// helper): avatar + title + sub line. Source of truth = the staff panes' header,
// promoted to a global so all four read identically.
export function PaneHeader({ avatar, title, sub, isNew, onAvatarClick, badge, right }: PaneHeaderProps) {
  const av = <Avatar name={avatar.name} id={avatar.id} kind={avatar.kind} size={42} />;
  return (
    <div className="pane-head">
      {onAvatarClick ? (
        <button type="button" className="pane-head-avatar" onClick={onAvatarClick} title="Edit owner" aria-label="Edit owner">
          {av}
        </button>
      ) : (
        av
      )}
      <div>
        <div className="pane-title">{title}{isNew && <span className="newbadge">New</span>}{badge}</div>
        {sub != null && <div className="pane-sub">{sub}</div>}
      </div>
      {right != null && <div className="pane-head-right">{right}</div>}
    </div>
  );
}
